import type { FacetOption } from '@/browse/browse_state'

export function facetOptionStateClasses(option: FacetOption): string {
  if (!option.isEnabled) {
    return 'cursor-not-allowed italic text-gray-700'
  }
  if (option.isSelected) {
    return 'cursor-pointer bg-blue-400 text-white'
  }
  return 'cursor-pointer text-blue-400 hover:bg-gray-200'
}

// Present Levels' look: a purple pill for the chosen option and dark text for the rest.
export function purpleFacetOptionStateClasses(option: FacetOption): string {
  if (!option.isEnabled) {
    return 'cursor-not-allowed italic text-gray-600'
  }
  if (option.isSelected) {
    return 'cursor-pointer bg-purple-300 text-white'
  }
  return 'cursor-pointer text-gray-900 hover:bg-gray-200'
}
